module.exports = __webpack_public_path__ + "static/media/AI-电机驱动.0e648fd1.jpg";